module.exports = __webpack_public_path__ + "assets/img/btn-detail-0a0b382c.png";